import type { IconSvgObject } from './types';

const PointingLeft03Icon: IconSvgObject = [
  ["path", { d: "M2.5 5L5 2.5M2.5 5L5 7.5M2.5 5H8.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12.171 8.37124L14 10.5051L4.25 10.5051C3.2835 10.5051 2.5 11.2886 2.5 12.2551C2.5 13.2216 3.2835 14.0051 4.25 14.0051H10.5V18.5C10.5 20.1569 11.8431 21.5 13.5 21.5H18.5C20.1569 21.5 21.5 20.1569 21.5 18.5V11.57C21.5 10.9015 21.166 10.2772 20.6099 9.90622L14.5883 5.88941C13.9531 5.37331 13.0441 5.36987 12.405 5.88114C11.6369 6.49565 11.5308 7.62437 12.171 8.37124Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default PointingLeft03Icon;
